import router from "@/router";
import Vue from "vue";
import axios from "axios";
import CONSTANTS from "@/constants.js";

//Apply -> Apply changes in Active Product

//Save -> Save finals changes

//Update -> Async calls to save changes

const playbook = {
  namespaced: true,

  state: () => ({
    template: process.env.VUE_APP_PLAYBOOK_TEMPLATE,
    title: "",
    teamName: "",
    repId: "",
    color_1: CONSTANTS.DEFAULT.C1,
    color_2: CONSTANTS.DEFAULT.C2,
    color_3: CONSTANTS.DEFAULT.C3,

    pages: [],
    logos: [],
    catalogs: [],
    customerType: "",
    defaultLogoId: "",
    lockerCode: "",
    schoolCode: null,
    travelTeamCode: null,
    status: "",
    playbookId: null,
    actualPage: 1,
    playbookLoading: false,
    showPrices: true,
    showCoverAndIndex: true,
    productTypeFilter: [],
    productTypeFilterDefault: ["Five day", "sublimation", "stock"],
    productGenderFilter: [],
    productGenderFilterDefault: ["men", "women"],
  }),

  getters: {
    getPlaybookCards: (state) => {
      return state.template === "FSG"
        ? CONSTANTS.FSG_PLAYBOOK_SPORTS_CARDS
        : CONSTANTS.UA_PLAYBOOK_SPORTS_CARDS;
    },

    projectHasDealerHeader: (state) => {
      return state.type === "showrooms"; //TODO get value from dealer options maybe?
    },

    color1: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.color_1;
      });
    },

    color2: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.color_2;
      });
    },

    color3: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.color_3;
      });
    },

    playbookPages: (state, _getters, rootState) => {
      let pages = [];

      state.catalogs?.forEach((catalog) => {
        //Search catalog's products
        const catalogProducts = rootState.catalog.projectProducts?.filter(
          (pr) => {
            return pr?.catalogName === catalog;
          }
        );

        //Separete by pages
        const pagesIndexes = [
          ...new Set(catalogProducts.map((pr) => pr?.catalog_page_index)),
        ];

        //Iterate over catalog products
        pagesIndexes.forEach((pageIndex) => {
          let pageProducts = catalogProducts.filter(
            (pr) => pr?.catalog_page_index === pageIndex
          );

          let pageType = pageProducts?.[0].catalogType;

          if (pageType === "5 Day") {
            pageType = "Five Day";
          }

          //Filter the products by allowed gender
          pageProducts = pageProducts?.filter((pr) => {
            const productDatatableAllowedGender = pr?.datatable_gender
              ?.replace("'s", "")
              ?.toLowerCase();
            const productGender = pr?.gender?.replace("'s", "")?.toLowerCase();

            return (
              productDatatableAllowedGender?.includes(productGender) ||
              productGender === "adult" ||
              productGender === "unisex"
            );
          });

          const page = {
            catalog,
            type: pageType,
            products: pageProducts.sort(
              (prA, prB) => prA?.catalog_page_order - prB?.catalog_page_order
            ),
          };

          //Check if the page has at least one product that is allowed to be shown by the catalog's genders filter

          if (pageProducts.length > 0) {
            pages.push(page);
          }
        });
      });

      return [
        ...CONSTANTS.BASE_PLAYBOOK_PAGES,
        ...pages,
        CONSTANTS.BACK_PLAYBOOK_PAGES,
      ];
    },

    filteredPages: (state, getters) => {
      if (!getters.playbookPages.length) return [];

      return getters.playbookPages.filter((page) => {
        //Show/hide Cover and Index filter
        if (
          page.type === "Cover" ||
          page.type === "Index" ||
          page.type === CONSTANTS.BACK_PLAYBOOK_PAGES.type
        ) {
          return state.showCoverAndIndex;
        }

        const return5Day =
          state.productTypeFilter?.includes("Five Day") &&
          page.type === "Five Day";

        const returnSublimation =
          state.productTypeFilter?.includes("Sublimated") &&
          page.type === "Sublimated";

        const returnStock =
          state.productTypeFilter?.includes("Stock") && page.type === "Stock";

        return return5Day || returnSublimation || returnStock;
      });
    },

    playbookColors: (_state, getters) => {
      return [getters.color1, getters.color2, getters.color3];
    },

    playbookProducts(_state, getters) {
      const productPages = getters.filteredPages?.filter((page) => {
        return (
          page.type !== "Cover" &&
          page.type !== "Index" &&
          page.type !== "BackCover"
        );
      });

      return productPages?.flatMap((page) => {
        return page.products;
      });
    },

    isUATemplate: (state) => {
      return state.template?.toLowerCase() === "ua";
    },

    isFSGTemplate: (state) => {
      return state.template?.toLowerCase() === "fsg";
    },

    branding: (state, _g, rootState) => {
      if (state.template?.toLowerCase() === "ua") {
        return {
          covers: [
            {
              graphic: "/images/branding/ua.png",
              url: "https://www.underarmour.com/en-us/",
              title: "Under Armour",
            },
          ],
        };
      }

      const covers = {
        alleson: {
          graphic: "/images/branding/alleson.png",

          title: "Alleson",
          items: [
            "• Authentic Uniforms at Exceptional Values",
            "• Best-in-class stock fabrications for all levels of play",
            "• Top selling styles guaranteed in-stock by season",
          ],
        },
        badger: {
          graphic: "/images/branding/badger.png",
          title: "Badger",
          items: [
            "• Performance Lab Approved Team, Practice and Spiritwear",
            "• Lifetime Guaranteed for no fade, no sweat, no stink performance",
            "• Top selling styles guaranteed in-stock",
          ],
        },
        chromagear: {
          graphic: "/images/branding/chromagear.png",
          title: "Chromagear",
          items: [
            "• Top Quality Cut-and-sew Custom sublimation",
            "• Names, numbers, colors and logos included",
            "• Made in North American, for reliable manufacture and shipping",
          ],
        },
      };

      const coversToShow = [];

      const isThereAnySport = rootState?.catalog.projectCatalogs?.some(
        (c) => c?.type?.toLowerCase() === "sport"
      );
      const isThereAnyCategory = rootState?.catalog.projectCatalogs?.some(
        (c) => c?.type?.toLowerCase() === "category"
      );

      const showAlleson = isThereAnySport;
      const showBadger = isThereAnyCategory;
      const showChromagear =
        state.productTypeFilter?.includes("Five Day") ||
        state.productTypeFilter?.includes("Sublimation");
      if (showAlleson) {
        coversToShow.push(covers.alleson);
      }
      if (showBadger) {
        coversToShow.push(covers.badger);
      }
      if (showChromagear) {
        coversToShow.push(covers.chromagear);
      }

      return coversToShow;
    },

    isSchool: (state) => {
      return state.customerType === "school";
    },

    isTeam: (state) => {
      return state.customerType === "team";
    },
  },

  actions: {
    triggerPlaybookStartLoading({ commit }) {
      commit("CHANGE_LOADING_STATE", true);
    },

    triggerPlaybookEndLoading({ commit }) {
      commit("CHANGE_LOADING_STATE", false);
    },

    async initPlaybook({ rootGetters, dispatch }) {
      try {
        //If we are in create mode, create a new snapsheet and set the id
        if (rootGetters["project/isCreateMode"]) {
          await dispatch("createPlaybook");
        } else {
          //Get the pb
          await dispatch("getPlaybook");
        }
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "error init pb",
            type: "error",
          },
          { root: true }
        );
        console.log(error);
      }
    },

    resetPlaybook({ state, commit }) {
      commit("SET_PLAYBOOK", {
        template: null,
        title: "",
        repId: "",
        color_1: CONSTANTS.DEFAULT.C1,
        color_2: CONSTANTS.DEFAULT.C2,
        color_3: CONSTANTS.DEFAULT.C3,
        customerType: "",
        catalogs: [],
        pages: [],
        logos: [],
        lockerCode: "",
        playbookId: null,
        actualPage: 1,
        schoolCode: null,
        travelTeamCode: null,
        showPrices: true,
        showCoverAndIndex: true,
        productTypeFilter: state.productTypeFilterDefault,
        productGenderFilter: state.productGenderFilterDefault,
      });
    },

    async createPlaybook({ rootState, dispatch }) {
      dispatch("triggerStartLoading", null, { root: true });

      try {
        const options = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        const response = await axios.post(
          rootState.settings.endpoint + `api/v2/catalog/create`,
          null,
          options
        );

        await dispatch("setPlaybook", {
          data: response.data,
          catalogs: response.data.catalogs,
        });
      } catch {
        dispatch(
          "showToast",
          {
            txt: "Error getting project",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async addSportToPlaybook({ rootState, state, dispatch }, { sport }) {
      dispatch("triggerStartLoading", null, { root: true });

      const params = { sport: sport?.name?.toLowerCase() };
      const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}/sport`;
      try {
        const { data } = await axios.put(url, params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        });
        await dispatch("setPlaybook", {
          data,
          catalogs: data.catalogs,
        });
        dispatch("project/setPage", 1, { root: true });
      } catch {
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async getPlaybook({ rootState, state, commit, dispatch }) {
      //Get the Playbook id from the most recent created or from the url param
      const playbookId =
        state.playbookId || router.currentRoute.params.project_id;
      commit("SET_PROJECT_ID", playbookId);
      const params = { dealer_code: router.currentRoute.params.dealer_code };
      const url = `${rootState.settings.endpoint}api/v2/catalog/${playbookId}`;
      try {
        const { data } = await axios.get(url, { params });

        await dispatch("setPlaybook", { data, catalogs: data.catalogs });

        //Push the rep to the reps lists in dealer module, if the rep list is empty
        if (!rootState.dealer?.reps?.length)
          dispatch("dealer/setAllReps", [data.rep], { root: true });
      } catch {
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async setPlaybook({ state, rootGetters, dispatch, commit }, { data }) {
      try {
        //Update Graphics
        const normalizedLogos = data.logos?.map((logo) => {
          return logo && rootGetters["uploadLogos/normalizeLogoData"](logo);
        });

        const playbookData = {
          template: data.template,
          color_1: data.color_1,
          color_2: data.color_2,
          color_3: data.color_3,
          catalogs: data.catalogs,
          type: "playbook",
          id: data.id,
          title: data.title,
          repId: data.rep_id,
          logos: data.logos,
          lockerCode: data.locker_code,
          teamName: data.team_name,
          default_logo_id: data.default_logo_id,
          schoolCode: data.school_code,
          travelTeamCode: data.travel_team_code,
          status: data.status,
          showPrices: data.show_prices,
          showCoverAndIndex: data.show_cover_and_index,
          productTypeFilter:
            data.product_selection_filter || state.productTypeFilterDefault,
          productGenderFilter:
            data.gender_filter || state.productGenderFilterDefault,
          customerType: data.customer_type,
        };

        playbookData.logos = normalizedLogos;

        commit("SET_PLAYBOOK", playbookData);

        await dispatch("project/setProjectLockerCode", data.locker_code, {
          root: true,
        });

        await dispatch("catalog/getProductsCatalogs", null, {
          root: true,
        });

        await dispatch("catalog/setProjectCatalogs", data.catalogs, {
          root: true,
        });
        await dispatch("catalog/setCatalogProducts", data.products, {
          root: true,
        });
        // await dispatch(
        //   "project/updateDecorationsForProjectProductsLayouts",
        //   null,
        //   {
        //     root: true,
        //   }
        // );

        //Update first two products Threekit data
        // await dispatch(
        //   "catalog/updateProductsThreekitData",
        //   rootState.catalog.projectProducts.slice(0, 2),
        //   {
        //     root: true,
        //   }
        // );

        await dispatch("triggerEndLoading", null, { root: true });

        // Update the rest of the products
        // dispatch(
        //   "catalog/updateProductsThreekitData",
        //   rootState.catalog.projectProducts.slice(2),
        //   {
        //     root: true,
        //   }
        // );
      } catch (error) {
        console.log(error);
      }
    },

    // setPlaybookPages({ rootState, state, commit }) {
    //   console.log("state.catalogs: ", state.catalogs);

    //   if (state.catalogs) {

    //     commit("SET_PLAYBOOK_PAGES", pages);
    //   }
    // },

    async setIndexOrder({ rootState, state, dispatch, getters }, payload) {
      dispatch("triggerPlaybookStartLoading");
      let sortedArray = [];

      payload.catalogs.forEach((sport, index) => {
        sortedArray.push({
          sport: (getters.isFSGTemplate
            ? "fsg_" + sport.name
            : "ua_" + sport.name
          ).toLowerCase(),
          order: index * 1 + 1,
        });
      });

      const params = {
        catalogs: sortedArray,
      };
      const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}/reorder-catalogs`;
      try {
        await axios.put(url, params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        });

        await dispatch("getPlaybook");
        dispatch("triggerPlaybookEndLoading");
      } catch {
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      }
    },

    async editSportName({ rootState, state, dispatch }, payload) {
      const params = payload;
      const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}/rename-sport`;
      try {
        await axios.put(url, params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        });
      } catch {
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    setPlaybookId({ commit }) {
      const playbookId = router.currentRoute.params.project_id;
      commit("SET_PROJECT_ID", playbookId);
    },

    async updatePlaybookItem({ state, dispatch, rootState }, payload) {
      // dispatch('triggerStartLoading', null, { root: true })
      const customCatalogProductId = payload.custom_catalog_product_id;

      const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}/product/${customCatalogProductId}/edit`;

      const settings = !payload.public
        ? {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + rootState.auth.apiToken,
            },
          }
        : null;

      try {
        await axios.put(url, payload, settings);

        await dispatch("catalog/updateProjectProduct", payload, { root: true });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async swapProductOrders(
      { rootState, dispatch },
      { catalog_page_index, catalog_page_order, action }
    ) {
      // const url = rootState.settings.endpoint + `api/snapsheetproducts/swap-orders`
      dispatch("project/triggerLoading", null, { root: true });
      dispatch("project/showSaveIndicator", null, { root: true });

      try {
        const order1 = catalog_page_order;
        const order2 =
          action === "up" ? catalog_page_order - 1 : catalog_page_order + 1;

        const product_1 = rootState.catalog.projectProducts?.find((pr) => {
          return (
            pr.catalog_page_index === catalog_page_index &&
            pr.catalog_page_order === order1
          );
        });

        const product_2 = rootState.catalog.projectProducts?.find((pr) => {
          return (
            pr.catalog_page_index === catalog_page_index &&
            pr.catalog_page_order === order2
          );
        });

        product_1.catalog_page_order = order2;
        product_2.catalog_page_order = order1;

        //Update the order
        await dispatch("updateProductOrder", product_1);
        await dispatch("updateProductOrder", product_2);

        await dispatch("catalog/setProjectProduct", product_1, { root: true });
        await dispatch("catalog/setProjectProduct", product_2, { root: true });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error updating snapsheet settings",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("project/endLoading", null, { root: true });
      }
    },

    async updateProductOrder({ rootState, state, dispatch }, product) {
      const { id, catalog_page_index, catalog_page_order } = product;

      const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}/product/${id}/update-order`;

      let params = {
        custom_catalog_product_id: id,
        catalog_page_index,
        catalog_page_order,
      };

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };

      try {
        await axios.put(url, params, settings);
      } catch (error) {
        {
          dispatch(
            "showToast",
            {
              txt: "Error trying to update the product",
              type: "error",
            },
            { root: true }
          );
        }
      }
    },

    async deletePlaybookItem(
      { rootState, state, dispatch },
      customCatalogProductId
    ) {
      dispatch("triggerStartLoading", null, { root: true });

      const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}/product/${customCatalogProductId}/delete`;

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };

      try {
        await axios.post(
          url,
          { custom_catalog_product_id: customCatalogProductId },
          settings
        );
        await dispatch("catalog/removeProjectProduct", customCatalogProductId, {
          root: true,
        });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "Error trying to delete the product",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async updatePlaybookItemDecorations({ dispatch, commit }, payload) {
      const { product } = payload;
      try {
        await dispatch("updatePlaybookItem", {
          ...payload,
          variant: product.variant,
          decorations: product.decorations,
          layout: product.layoutIndex,
          sport: product.sport,
          public: true,
        });
        //layoutIndex => it is the index of the sport page
        commit("SET_PRODUCT", payload);
      } catch (error) {
        console.log(error);
      }
    },

    async updateHeroDecorations({ dispatch }, payload) {
      const { product } = payload;
      try {
        await dispatch("updatePlaybookItem", {
          ...payload,
          decorations: product.decorations,
          layout: product.layoutIndex,
          sport: product.sport,
        });
        //layoutIndex => it is the index of the sport page
      } catch (error) {
        console.log(error);
      }
    },

    async bulkUpdatePlaybook({ dispatch, rootState, state }, payload) {
      dispatch("triggerStartLoading", null, { root: true });

      const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}`;
      try {
        await axios.put(url, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        });

        await dispatch("project/getProject", null, { root: true });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async updatePlaybook(
      { commit, dispatch, rootState, state },
      { dbKey, field, value, skipLoader }
    ) {
      console.log({ dbKey, field, value, skipLoader });
      if (!skipLoader) {
        dispatch("triggerStartLoading", null, { root: true });
      }

      let params = {
        [dbKey]: value,
      };

      const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}`;
      try {
        await axios.put(url, params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        });

        commit("SET_PLAYBOOK_DATA", { [field]: value });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async updateProductsFilter(
      { state, dispatch },
      { filterName, filterValue }
    ) {
      try {
        const newFilters = state[filterName].includes(filterValue)
          ? state[filterName].filter((f) => f !== filterValue)
          : [...state[filterName], filterValue];

        if (filterName === "productTypeFilter") {
          await dispatch("updatePlaybook", {
            dbKey: "product_selection_filter",
            field: "productTypeFilter",
            value: newFilters,
          });
        } else {
          await dispatch("updateGendersFilter", newFilters);
        }
      } catch (error) {
        console.log(error);
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async updateGendersFilter({ rootState, state, dispatch }, newFilters) {
      try {
        dispatch("triggerStartLoading", null, { root: true });

        let params = {
          gender_filter: newFilters,
        };

        const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}/update-genders-filter`;

        const updated = await axios.put(url, params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        });

        await dispatch("setPlaybook", { data: updated?.data });

        //Go to first page to avoid pagination bugs
        dispatch("project/setPage", 1, { root: true });
      } catch (error) {
        console.log(error);
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async updateShowPrices({ dispatch }, showPrices) {
      try {
        await dispatch("updatePlaybook", {
          dbKey: "show_prices",
          field: "showPrices",
          value: showPrices,
          skipLoader: true,
        });
      } catch (error) {
        console.log(error);
      }
    },

    async updatePlaybookBySchool({ rootState, state, dispatch }, payload) {
      try {
        dispatch("triggerStartLoading", null, { root: true });
        const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}/edit-bulk`;
        //Bulk update for... sublimable items? not sure what it does :*)
        await axios.put(url, {
          color_1: payload.color_1,
          color_2: payload.color_2,
          color_3: payload.color_3,
        });

        const paramsToUpdate = {
          color_1: payload.color_1,
          color_2: payload.color_2,
          color_3: payload.color_3,
          title: payload.schoolName,
          team_name: payload.mascot,
          school_code: payload.schoolCode,
        };

        //update default logo
        if (payload.logosIds?.length) {
          paramsToUpdate["default_logo_id"] = payload.logosIds[0];
        }

        //Before the playbook update, delete the previuos logos
        const previousLogosIds = rootState.project.projectLogos?.map(
          (logo) => logo.id
        );

        if (previousLogosIds.length > 0) {
          for (const prevLogoId of previousLogosIds) {
            await dispatch("project/deleteProjectLogo", prevLogoId, {
              root: true,
            });
          }
        }

        //Before the playbook update, update the logos's project_id property
        if (payload.logosIds) {
          for (const logoId of payload.logosIds) {
            await dispatch("updatePlaybookLogoBySelectedSchool", logoId);
          }
        }

        await dispatch("bulkUpdatePlaybook", paramsToUpdate);
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async updatePlaybookColor(
      { rootState, rootGetters, state, dispatch, commit },
      { colorKey, colorId }
    ) {
      try {
        dispatch("triggerStartLoading", null, { root: true });

        const url = `${rootState.settings.endpoint}api/v2/catalog/${state.playbookId}/edit-bulk`;

        const color_1 = rootGetters["project/projectColors"][0].color.id;
        const color_2 = rootGetters["project/projectColors"][1].color.id;
        const color_3 = rootGetters["project/projectColors"][2].color.id;

        await axios.put(url, {
          color_1,
          color_2,
          color_3,
          [colorKey]: colorId,
        });

        commit("SET_PLAYBOOK_DATA", {
          color_1,
          color_2,
          color_3,
          [colorKey]: colorId,
        });

        //update field in db using public endpoint
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async uploadPlaybookLogo(
      { rootState, state, dispatch },
      { logo, typesOfLogo }
    ) {
      dispatch("triggerStartLoading", null, { root: true });
      //axios post
      const playbookId = state.playbookId;
      const url = rootState.settings.endpoint + `api/logos/${logo.id}`;

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };

      let params = {
        project_type: "playbook",
        project_id: playbookId,
      };

      let types = [];

      //Check the types of logo
      const isSpiritwearLogo = typesOfLogo.includes("spiritwear");
      const isUniformsLogo = typesOfLogo.includes("uniforms");

      if (isSpiritwearLogo) {
        types.push("spiritwear");
      }
      if (isUniformsLogo) {
        types.push("uniforms");
      }
      //Add types to params
      params["type"] = types;

      try {
        const updatedLogo = await axios.put(url, params, settings);
        await dispatch("addPlaybookLogo", updatedLogo);
        //Only apply the new updatedLogo if the apply mode is 'project'
        if (rootState.uploadLogos.applyMode === "project") {
          if (isSpiritwearLogo)
            await dispatch("setPlaybookSelectedLogo", {
              action: "on",
              logoId: updatedLogo.id,
              typeOfLogo: "spiritwear",
            });
          if (isUniformsLogo)
            await dispatch("setPlaybookSelectedLogo", {
              action: "on",
              logoId: updatedLogo.id,
              typeOfLogo: "uniforms",
            });
        }
        //Reset the apply mode
        dispatch("uploadLogos/setApplyMode", "project", { root: true });
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async updatePlaybookLogoBySelectedSchool(
      { rootState, state, dispatch },
      logoId
    ) {
      try {
        dispatch("triggerStartLoading", null, { root: true });
        //axios post
        const playbookId = state.playbookId;
        const url = rootState.settings.endpoint + `api/logos/${logoId}`;

        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        let params = {
          project_type: "playbook",
          project_id: playbookId,
        };

        await axios.put(url, params, settings);
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "error trying to update school logos",
            type: "error",
          },
          { root: true }
        );
        console.log(error);
      }
    },

    addPlaybookLogo({ commit }, logo) {
      commit("ADD_PLAYBOOK_LOGO", logo);
    },

    async setPlaybookSelectedLogo(
      { dispatch, commit },
      { action, logoId, typeOfLogo }
    ) {
      dispatch("triggerStartLoading", null, { root: true });

      const isSpiritwearLogo = typeOfLogo === "spiritwear";
      //Action === 'ON' =>  Set
      //Action === 'OFF' => Remove
      const isActionSet = action === "on";
      const finalLogoId = isActionSet ? logoId : null;

      isSpiritwearLogo
        ? commit("SET_SPIRITWEAR_LOGO_ID", finalLogoId)
        : commit("SET_UNIFORMS_LOGO_ID", finalLogoId);

      dispatch("triggerEndLoading", null, { root: true });
    },

    async updatePlaybookSelectedTypeOfLogo(
      { rootState, dispatch },
      { action, logoId, typeOfLogo }
    ) {
      try {
        //axios PUT
        const url = `${rootState.settings.endpoint}api/logos/set-type/${logoId}`;
        const params = {
          project_type: "catalog",
          type: typeOfLogo,
          action,
        };
        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        await axios.put(url, params, settings);

        //Set the selected logo
        await dispatch("setPlaybookSelectedLogo", {
          action,
          logoId,
          typeOfLogo,
        });
      } catch (error) {
        console.log(error);
      }
    },

    setPage({ commit }, number) {
      commit("SET_PAGE", number);
    },
  },

  mutations: {
    CHANGE_LOADING_STATE: (state, bool) => (state.playbookLoading = bool),

    SET_PROJECT_ID: (state, id) => (state.playbookId = id),

    REORDER_SPORTS: (state, payload) => {
      const sorted = state.catalogs;
      for (let index = 0; index < state.catalogs.length; index++) {
        const sport = state.catalogs[index];
        sport.order = payload.catalogs.find((s) => {
          return (
            s.sport ===
            state.template.toLowerCase() + "_" + sport.name.toLowerCase()
          );
        })?.order;
      }
      state.catalogs = sorted;
    },

    SET_PLAYBOOK_PAGES: (state, pages) => {
      const projectPages = pages || [];
      state.pages = [
        ...CONSTANTS.BASE_PLAYBOOK_PAGES,
        ...projectPages,
        CONSTANTS.BACK_PLAYBOOK_PAGES,
      ];
    },

    SET_PLAYBOOK: (state, projectData) => {
      if (projectData.id) state.playbookId = projectData.id;
      if (projectData.color_1) state.color_1 = projectData.color_1;
      if (projectData.color_2) state.color_2 = projectData.color_2;
      if (projectData.color_3) state.color_3 = projectData.color_3;
      if (projectData.catalogs) state.catalogs = projectData.catalogs;
      if (projectData.type) state.type = projectData.type;
      if (projectData.title) state.title = projectData.title;
      if (projectData.repId) state.repId = projectData.repId;
      if (projectData.template_id) state.templateId = projectData.template_id;
      if (projectData.logos) state.logos = projectData.logos;
      if (projectData.lockerCode) state.lockerCode = projectData.lockerCode;
      if (projectData.schoolCode) state.schoolCode = projectData.schoolCode;
      if (projectData.travelTeamCode)
        state.travelTeamCode = projectData.travelTeamCode;
      if (projectData.teamName?.length) state.teamName = projectData.teamName;
      state.status = projectData.deleted_at
        ? CONSTANTS.PROJECT_STATUS.ARCHIVED
        : projectData.status;
      state.customerType = projectData.customerType;
      state.showPrices = !!projectData.showPrices;
      state.showCoverAndIndex = !!projectData.showCoverAndIndex;
      state.defaultLogoId = projectData.default_logo_id || null;
      state.productGenderFilter =
        projectData.gender_filter ||
        projectData.productGenderFilter ||
        state.productGenderFilterDefault;
      state.productTypeFilter =
        projectData.productTypeFilter ||
        projectData.product_selection_filter ||
        state.productTypeFilterDefault;
    },

    SET_PLAYBOOK_DATA(state, payload) {
      const keys = Object.keys(payload);
      for (let index = 0; index < keys.length; index++) {
        const field = keys[index];
        state[field] = payload[field];
      }
    },

    SET_PROJECT_LOCKER_CODE(state, code) {
      state.lockerCode = code;
    },

    SET_PAGE: (state, page) => {
      state.actualPage = page;
    },

    SET_PLAYBOOK_COLOR(state, { color, colorKey }) {
      state[colorKey] = color.id;
    },

    ADD_PLAYBOOK_LOGO: (state, logo) => {
      state.logos.push(logo);
    },

    REMOVE_PLAYBOOK_LOGO: (state, logoIndex) => {
      Vue.delete(state.logos, logoIndex);
    },

    //Products Changes
    SET_PRODUCT: (state, { pageId, column, block, product }) => {
      Vue.set(
        state.pages[pageId - 1].columns[column][block],
        "product",
        product
      );
    },
  },
};

export default playbook;
